export default __webpack_public_path__ + "static/media/308.9bdd08ff.jpg";